export default __webpack_public_path__ + "static/media/saas.f9d46451.svg";